import React, {
  useState,
  useEffect,
  useRef,
  useReducer,
  useCallback,
} from "react"
import { connect } from "react-redux"
import {
  Table,
  Input,
  Button,
  Row,
  Col,
  Form,
  Select,
  Divider,
  Radio,
  Space,
  Collapse,
  Card,
} from "antd"
import { PlusOutlined, SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import { columns } from "./columns"
import {
  addSupportFile,
  closedSupport,
  deleteSupportFile,
  getListEngineer,
  getListExecutor,
  getListSupport,
  getSupportFiles,
  resetSupportFlag,
  switchSupport,
  upsertSupport,
  getGasProjects,
} from "store/actions"
import { withTranslation } from "react-i18next"
import {
  enumToArray,
  getCurrentUser,
  serializeQuery,
} from "helpers/service_helper"
import FilePondUpload from "components/Common/FilePondUpload"
import { FileGasProjectType } from "models/types/file-gas-project-type"
import { ListEngineer } from "./ListEngineer"
import { ListExecutor } from "./ListExecutor"
import { Switch } from "antd"
import { debounce } from "lodash"

const { Search } = Input
const { Panel } = Collapse
const { Option } = Select

const SupportList = props => {
  const {
    lstSupport,
    lstGasProjects,
    loading,
    onGetListSupport,
    onUpsertSupport,
    onResetSupportFlag,
    onGetGasProjects,
    openNotification,
    reload,
  } = props
  const [errorMessage, setErrorMessage] = useState(null)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      closed: 0,
      userType: 0,
    }
  )
  const [engineerId, setEngineerId] = useState(null)
  const [executorId, setExecutorId] = useState(null)
  const [hasFileNumber, setHasFileNumber] = useState(true)
  const [selectedFileNumbers, setSelectedFileNumbers] = useState([])
  const [form] = Form.useForm()
  const [supportFile, setSupportFile] = useState([])
  const [activeKey, setActiveKey] = useState([])

  const [countChangeFormInput, setCountChangeFormInput] = useState(0)

  // Track if component is mounted to prevent state updates after unmount
  const isMountedRef = useRef(true)

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
    setCountChangeFormInput(prev => prev + 1)
  }
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra)
  }
  const [fileGasProjectTypes, setFileGasProjectTypes] = useState([])

  useEffect(() => {
    setFileGasProjectTypes(enumToArray(FileGasProjectType))
  }, [])

  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetSupportFlag()
  }, [errorMessage, props.success, props.error])

  useEffect(() => {
    const fetchInitialData = async () => {
      await handleSearchSupports()
      // Fetch gas projects for file number dropdown
      onGetGasProjects({
        searchValue: "",
        page: 0,
        pageSize: 10,
        quickSearch: true,
      })
    }
    fetchInitialData()
  }, [])

  // Fetch data or set initial values if needed
  useEffect(() => {
    const fetchData = async () => {
      if (reload) {
        await handleSearchSupports()
      }
      if (countChangeFormInput) {
        await handleSearchSupports()
      }
    }
    fetchData()
  }, [reload, countChangeFormInput])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      isMountedRef.current = false
      debouncedFetchGasProjects.cancel()
    }
  }, [])
  // Function to handle form submission
  const handleSubmit = values => {
    let searchQuery = {
      ...formInput,
      closed: !!formInput.closed,
    }
    const params = serializeQuery(searchQuery)

    let updatedData = values
    // delete updatedData.julianBirthDate
    // delete updatedData.julianMembershipDate

    let formData = new FormData()

    formData.append("title", "مشکل در پرونده")
    formData.append("message", updatedData.message)

    // Handle fileNumbers array - append each item separately
    // Get fileNumbers from form values instead of state
    const fileNumbers = updatedData.fileNumbers || []
    if (fileNumbers.length > 0) {
      fileNumbers.forEach(fileNumber => {
        formData.append("fileNumbers", fileNumber)
      })
    }

    formData.append("toRole", "Administrator")
    formData.append("userId", getCurrentUser().sid)
    if (engineerId) formData.append("toUserId", engineerId ? engineerId : "")
    if (executorId) formData.append("toUserId", executorId ? executorId : "")

    if (supportFile[0]) {
      let file = supportFile[0].file
      const fileName = FileGasProjectType[30]
      formData.append(
        "file",
        file,
        fileName + "." + file.name.split(".")[file.name.split(".").length - 1]
      )
      formData.append("name", "support-" + fileName)
      formData.append("des", `Upload with-${getCurrentUser().sid}`)
      // formData.append("fileTypeEnum", fileName)
      formData.append("FolderName", "Supports")
      formData.append(
        "FileName",
        fileName + "." + file.name.split(".")[file.name.split(".").length - 1]
      )
    }

    onUpsertSupport({ formData, params })
    form.resetFields()
    setSelectedFileNumbers([])
  }
  const handleSearchSupports = async param => {
    let searchQuery = {
      ...formInput,
      closed: !!formInput.closed,
    }
    if (param) {
      searchQuery = { ...searchQuery, ...param }
    }
    const params = serializeQuery(searchQuery)
    onGetListSupport(params)
  }
  // Function to handle edit button click
  const handleEdit = record => {
    // form.setFieldsValue(record)
  }

  const onTicketSearch = async value => {
    await handleSearchSupports(value ? value : 0)
  }

  // Handle file number search in dropdown with debounce
  const debouncedFetchGasProjects = useCallback(
    debounce(searchValue => {
      onGetGasProjects({
        searchValue: searchValue ?? "",
        page: 0,
        pageSize: 10,
        quickSearch: true,
      })
    }, 500), // 500ms delay
    [onGetGasProjects]
  )

  const handleFileNumberSearch = searchValue => {
    debouncedFetchGasProjects(searchValue)
  }

  return (
    <>
      {/* Modern Form Section */}
      <Collapse
        activeKey={activeKey}
        onChange={setActiveKey}
        size="small"
        style={{ marginBottom: 16 }}
        items={[
          {
            key: "0",
            label: (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PlusOutlined />
                <span>ایجاد تیکت جدید</span>
              </div>
            ),
            children: (
              <Card size="small" style={{ backgroundColor: "#fafafa" }}>
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  style={{ margin: 0 }}
                >
                  <Row gutter={[16, 8]}>
                    {/* Engineer/Executor Selection */}
                    {getCurrentUser().role === "Administrator" && !executorId && (
                      <Col xs={24} lg={12}>
                        <Form.Item label="ارسال به کارشناس">
                          <ListEngineer
                            selectEngineer={setEngineerId}
                            props={props}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {getCurrentUser().role === "Administrator" && !engineerId && (
                      <Col xs={24} lg={12}>
                        <Form.Item label="ارسال به مجری">
                          <ListExecutor
                            selectExecutor={setExecutorId}
                            props={props}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    {/* File Number Switch */}
                    <Col xs={24} md={12}>
                      <Form.Item label="آیا شماره پرونده دارد؟">
                        <Switch
                          checked={hasFileNumber}
                          onChange={setHasFileNumber}
                          checkedChildren="دارد"
                          unCheckedChildren="ندارد"
                        />
                      </Form.Item>
                    </Col>

                    {/* File Numbers Multi-Select */}
                    {hasFileNumber && (
                      <Col xs={24} md={12}>
                        <Form.Item
                          label="شماره پرونده‌ها"
                          name="fileNumbers"
                          rules={[
                            {
                              required: hasFileNumber,
                              message: "حداقل یک شماره پرونده انتخاب کنید",
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            placeholder="شماره پرونده‌ها را انتخاب کنید"
                            onChange={setSelectedFileNumbers}
                            showSearch
                            filterOption={false}
                            onSearch={handleFileNumberSearch}
                            notFoundContent={
                              loading ? "در حال بارگذاری..." : "موردی یافت نشد"
                            }
                            style={{ width: "100%" }}
                            allowClear
                          >
                            {lstGasProjects?.map(project => (
                              <Option
                                key={project.id}
                                value={project.fileNumber}
                              >
                                {project.fileNumber} -{" "}
                                {project.fullName || project.landlordName}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    )}

                    {/* Message */}
                    <Col xs={24}>
                      <Form.Item
                        label="توضیحات"
                        name="message"
                        rules={[{ required: true, message: "نباید خالی باشد" }]}
                      >
                        <Input.TextArea
                          rows={3}
                          placeholder="پیام خود را در اینجا بنویسید"
                        />
                      </Form.Item>
                    </Col>

                    {/* File Upload */}
                    <Col xs={24}>
                      <Form.Item label="فایل ضمیمه">
                        <FilePondUpload
                          setFiles={setSupportFile}
                          maxFileSize="3000KB"
                          allowMultiple={false}
                          maxFiles={1}
                          acceptedFileTypes={["image/png", "image/jpeg"]}
                          imagePreviewMaxHeight={200}
                          labelText="فایل مربوطه را اینجا بکشید"
                        />
                      </Form.Item>
                    </Col>

                    {/* Action Buttons */}
                    <Col xs={24}>
                      <Space>
                        <Button
                          type="primary"
                          htmlType="submit"
                          loading={loading}
                          icon={<PlusOutlined />}
                        >
                          ارسال
                        </Button>
                        <Button
                          htmlType="button"
                          icon={<ReloadOutlined />}
                          onClick={() => {
                            form.resetFields()
                            setSupportFile([])
                            setEngineerId(null)
                            setExecutorId(null)
                            setSelectedFileNumbers([])
                            setHasFileNumber(true)
                          }}
                        >
                          پاک کردن فرم
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                </Form>
              </Card>
            ),
          },
        ]}
      />

      {/* Search and Filter Section */}
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 8]} align="middle">
          {getCurrentUser().role === "Administrator" && (
            <Col xs={24} sm={12} md={6}>
              <Search
                placeholder="از طرف"
                allowClear
                enterButton={<SearchOutlined />}
                onSearch={value => value && onTicketSearch({ sender: value })}
              />
            </Col>
          )}

          {getCurrentUser().role === "Administrator" && (
            <Col xs={24} sm={12} md={6}>
              <Search
                placeholder="شماره تیکت"
                allowClear
                enterButton={<SearchOutlined />}
                onSearch={value =>
                  value && onTicketSearch({ ticketNumber: value })
                }
              />
            </Col>
          )}

          <Col xs={24} sm={12} md={6}>
            <Search
              placeholder="شماره پرونده"
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={value => value && onTicketSearch({ fileNumber: value })}
            />
          </Col>
          {getCurrentUser().role === "Administrator" && (
            <Col xs={24} md={6}>
              <Radio.Group
                name="closed"
                onChange={handleInput}
                value={formInput.closed}
              >
                <Radio.Button value={0}>باز</Radio.Button>
                <Radio.Button value={1}>بسته</Radio.Button>
              </Radio.Group>
            </Col>
          )}

          {getCurrentUser().role === "Administrator" && (
            <Col xs={24} md={6}>
              <Radio.Group
                name="userType"
                onChange={handleInput}
                value={formInput.userType}
                size="small"
              >
                <Radio.Button value={0}>همه</Radio.Button>
                <Radio.Button value={2}>مجری</Radio.Button>
                <Radio.Button value={1}>کارشناس</Radio.Button>
              </Radio.Group>
            </Col>
          )}

          <Col>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => setCountChangeFormInput(prev => prev + 1)}
            >
              به روز رسانی
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Table Section */}
      <Table
        loading={loading}
        size="small"
        pagination={{
          pageSize: 20,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} از ${total} مورد`,
        }}
        scroll={{
          y: 600,
          x: 1200,
        }}
        sticky
        columns={columns({
          props,
          handleEdit,
          currentUser: getCurrentUser(),
          ticketNumberFilter: lstSupport.map(x => ({
            text: x.ticketNumber,
            value: x.ticketNumber,
          })),
        })}
        rowClassName={(_r, i) => (i % 2 ? "odd" : "even")}
        rowKey={record => record.id}
        dataSource={lstSupport}
        onChange={onChange}
      />
    </>
  )
}

const mapStateToProps = ({ Supports, Engineers, Executors, GasProjects }) => ({
  lstSupport: Supports.lstSupport,
  lstSupportFiles: Supports.lstSupportFiles,
  lstExecutor: Executors.lstExecutor,
  lstEngineer: Engineers.lstEngineer,
  lstGasProjects: GasProjects.lstGasProjects,
  loading: Supports.loading,
  error: Supports.error,
  success: Supports.success,
  triggerReload: Supports.triggerReload,
})

const mapDispatchToProps = dispatch => ({
  onGetListSupport: searchValue => dispatch(getListSupport(searchValue)),
  onUpsertSupport: data => dispatch(upsertSupport(data)),
  onResetSupportFlag: () => dispatch(resetSupportFlag()),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onClosedSupport: data => dispatch(closedSupport(data)),
  onSwitchSupport: data => dispatch(switchSupport(data)),
  onAddSupportFile: supportId => dispatch(addSupportFile(supportId)),
  onGetSupportFiles: supportId => dispatch(getSupportFiles(supportId)),
  onDeleteSupportFiles: id => dispatch(deleteSupportFile(id)),
  onGetListExecutor: () => dispatch(getListExecutor()),
  onGetGasProjects: payload => dispatch(getGasProjects(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SupportList))
